import Api from './Api';
const endPoint = 'Form';
const publishform = "PublishedForms";
const applicationPoint = 'Application';

const getApplications = applications => Api.get(`${applicationPoint}/get-all`, applications);
const getAllForms = forms => Api.get(`${endPoint}/get-all`, forms);
const getForms = forms => Api.post(`${endPoint}/filter`, forms);
const saveForm = form => Api.post(`${endPoint}/${form.IsEditMode ? 'update' : 'add'}`, form);
const cloneForm = form => Api.post(`${endPoint}/clone`, form);
const saveFromSchema = formSchema => Api.post(`${endPoint}/save-from-schema`, formSchema);
const getSelectedform = form => Api.get(`${endPoint}/get`, { params: { formid: form } });
//const getSelectedform = form => Api.get(`${endPoint}/get`, form);
const activedeactiveForm = form => Api.post(`${endPoint}/${form.isActive ? 'deactivate-form' : 'activate-form'}`, form);
const requestForReview = form => Api.post(`${endPoint}/request-for-review`, form);
const requestForApproval = form => Api.post(`${endPoint}/request-for-approval`, form);
const requestForReject = form => Api.post(`${endPoint}/request-for-reject`, form);
const requestForPublish = form => Api.post(`${endPoint}/request-for-publish`, form);
const getPublishedForm = form => Api.get(`${publishform}/get-form`, { params: { appicationid: form.applicationId,formid: form.formId}});
const getPublishedFormCollection = form => Api.get(`${publishform}/get-form-collection`, { params: { form } });
const revertBackToPublishedForm = form => Api.get(`${endPoint}/revert-form`, { params: { applicationid: form.applicationId,formid: form.formId}});

export {
   getForms,
   saveForm,
   saveFromSchema,
   getSelectedform,
   activedeactiveForm,
   requestForApproval,
   requestForReject,
   requestForPublish,
   requestForReview,
   getPublishedForm,
   getPublishedFormCollection,
   getApplications,
   getAllForms,
   cloneForm,
   revertBackToPublishedForm,
};